export const SELECT_USER_PREFERENCES = `SELECT_USER_PREFERENCES`;

export const selectUserPreferences = (id) => ({
  type: SELECT_USER_PREFERENCES,
  id,
});
